import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import notify from 'devextreme/ui/notify';

@Injectable()
export class NotificationService {
  private toastOptions = {
    message: '',
    width: '300px',
    position: {
      my: 'right top',
      at: 'right top',
      offset: '-25 25'
    },
    closeOnClick: true,
    visible: false,
    elementAttr: {
      style: 'cursor: pointer;'
    }
  }
  // The message's type: "info", "warning", "error" or "success".
  private type = 'error';
  private duration = 10000;

  showNotification(message: string, type?: string, duration?: number) {
    /*
    / DevExtreme Toast doesn't support notification stacking
    / so we remove all existing notifications before adding a new one
    /
    / TODO: implement stacking using dynamical positioning of the notification
    */
    this.clearNotifications();

    this.toastOptions.message = message;
    notify(this.toastOptions, type || this.type, duration || this.duration);
  }

  clearNotifications() {
    $('.dx-toast .dx-toast-content').trigger('click');
  }

  showMultipleNotification(notifications: string[], type?: string, duration?: number) {
    const toastOptions = {
      message: '',
      width: '300px',
      position: {
        my: 'right top',
        at: 'right top',
        offset: '-25 25'
      },
      closeOnClick: true,
      visible: false,
      elementAttr: {
        style: 'cursor: pointer;'
      }
    }
      notifications.forEach((notification, index ) => {
      toastOptions.message = notification;
      toastOptions.position.offset = '-25 ' + (index * 100).toString();
      notify(toastOptions, type || this.type, duration || this.duration);
    })
  }
}



// WEBPACK FOOTER //
// ./src/app/core/api/notification.service.ts